var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: "编辑风险策略",
            "close-on-click-modal": false,
            top: "80px",
            "append-to-body": "",
          },
        },
        "el-dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _c(
        "el-form",
        {
          ref: "formRef",
          attrs: {
            "label-width": "120px",
            model: _vm.riskForm,
            rules: _vm.formRules,
          },
        },
        [
          _c(
            "el-form-item",
            { attrs: { label: "风险等级", prop: "level" } },
            [
              _c(
                "el-select",
                {
                  staticStyle: { width: "200px" },
                  attrs: {
                    size: "small",
                    filterable: "",
                    clearable: "",
                    placeholder: "风险等级",
                    disabled: "",
                  },
                  model: {
                    value: _vm.riskForm.level,
                    callback: function ($$v) {
                      _vm.$set(_vm.riskForm, "level", $$v)
                    },
                    expression: "riskForm.level",
                  },
                },
                _vm._l(_vm.riskOptions, function (item) {
                  return _c("el-option", {
                    key: item.value,
                    attrs: {
                      label: item.label,
                      value: item.value,
                      disabled: item.disabled,
                    },
                  })
                }),
                1
              ),
            ],
            1
          ),
          _c(
            "el-card",
            {
              staticStyle: { "margin-top": "20px" },
              attrs: { shadow: "never" },
              scopedSlots: _vm._u([
                {
                  key: "header",
                  fn: function () {
                    return [
                      _c("div", { staticClass: "card-header" }, [
                        _vm._v("执行策略"),
                      ]),
                    ]
                  },
                  proxy: true,
                },
              ]),
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "执行策略", prop: "limitCode" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            model: {
                              value: _vm.riskForm.limitCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.riskForm, "limitCode", $$v)
                              },
                              expression: "riskForm.limitCode",
                            },
                          },
                          _vm._l(_vm.strategyDescOptions, function (item) {
                            return _c(
                              "el-checkbox",
                              {
                                key: item.label,
                                staticStyle: { display: "block" },
                                attrs: { label: item.label },
                              },
                              [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(item.key) +
                                    "\n                "
                                ),
                                _c("div", { staticClass: "info" }, [
                                  _vm._v(
                                    "\n                  " +
                                      _vm._s(item.text) +
                                      "\n                "
                                  ),
                                ]),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
          _c(
            "el-card",
            {
              staticStyle: { "margin-top": "25px" },
              attrs: { shadow: "never" },
            },
            [
              _c("div", { staticClass: "container" }, [
                _c(
                  "div",
                  { staticClass: "content" },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注", prop: "remark" } },
                      [
                        _c("el-input", {
                          attrs: { type: "textarea", maxlength: "500" },
                          model: {
                            value: _vm.riskForm.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.riskForm, "remark", $$v)
                            },
                            expression: "riskForm.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: _vm.saveLoading },
              on: { click: _vm.onSave },
            },
            [_vm._v("保存")]
          ),
          _c("el-button", { on: { click: _vm.cancel } }, [_vm._v("取消")]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }